import { Component, EventEmitter, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { standardvalidators } from '@configuration/standard-validators'
import { messages } from '@configuration/messages'
import { RestService } from '@service/rest/rest.service'
import { MatDialog } from '@angular/material/dialog'
import { ConfirmDialogComponent } from '@modal/confirm-dialog/confirm-dialog.component'
import { DialogType } from '@type/dialog-type'

@Component({
  selector: 'app-change-mail-dialog',
  templateUrl: './change-mail-dialog.component.html',
  styleUrls: ['./change-mail-dialog.component.scss']
})
export class ChangeMailDialogComponent {

  public static cssClass: DialogType = 'black-centered-dialog'

  public messages = messages

  public form: FormGroup = this.formBuilder.group(
    { email: ['', [standardvalidators.validEmail, Validators.required]] }
  )

  constructor(
    public dialogRef: MatDialogRef<ChangeMailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private formBuilder: FormBuilder,
    private restService: RestService,
    private dialog: MatDialog,
  ) { }

  public submitButtonClick() {

    if (!this.form.valid)
      return

    this.restService.post('frontendUser/changeMail', { email: this.form.controls.email.value })
      .then(result => {

        this.dialogRef.close()

        const dialogConfig = {
          text: 'Dein Änderungsantrag wurde an uns gesandt. Wir werden die Email Adresse zeitnah verifizieren und für dich eintragen. Das kann 1 - 7 Tage dauern. Danach kannst Du dich in deinem Profil mit der neuen Email Adresse anmelden.',
          buttons: [
            {
              text: 'OK',
              value: '',
            },
          ],
        }
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          data: dialogConfig,
          disableClose: false,
          panelClass: ConfirmDialogComponent.cssClass
        })
      })
  }
}